import moment from "moment";

export class FilterDaterangeController {
    public static $inject: string[] = [
        "$scope",
        "dateService"
    ];

    // Binded
    public from: string;
    public to: string;
    public datetimeRange: string;

    public fromDate: Date;
    public toDate: Date;
    public maxDate: Date;

    constructor(
        $scope: ng.IScope,
        private dateService
    ) {
        $scope.$watchCollection(
            () => ([this.fromDate, this.toDate, this.from, this.to, this.datetimeRange]),
            (current, previous) => {
                if (angular.equals(current, previous)) {
                    return;
                }

                const fromDate = current[0];
                const toDate = current[1] && moment(current[1]).endOf("day").toDate();

                const from = current[2];
                const to = current[3];
                const datetimeRange = current[4];

                const previousFrom = previous[2];
                const previousTo = previous[3];
                const previousDatetimeRange = previous[4];

                this.from = this.dateService.format(fromDate);
                this.to = this.dateService.format(toDate);
                this.datetimeRange = `${this.from || ""},${this.to || ""}`;

                this.maxDate = this.dateService.toDate(this.from);

                // Reset
                if (!from && from !== previousFrom) {
                    this.fromDate = null;
                }
                if (!to && to !== previousTo) {
                    this.toDate = null;
                }
                if (!datetimeRange && datetimeRange !== previousDatetimeRange) {
                    this.fromDate = null;
                    this.toDate = null;
                }
            }
        );
    }

    public $onInit() {
        if (this.from) {
            this.fromDate = this.dateService.toDate(this.from);
            this.maxDate = moment(this.from).add(1, "days").toDate();
        }

        if (this.to) {
            this.toDate = moment(this.to).endOf("day").toDate();
        }

        if (this.datetimeRange) {
            const [from, to] = this.datetimeRange.split(",");
            this.fromDate = this.dateService.toDate(from);
            this.toDate = moment(to).endOf("day").toDate();
        }
    }
}
